import { render, staticRenderFns } from "./AccountCenter.vue?vue&type=template&id=1b5911cc&scoped=true&lang=pug&"
import script from "./AccountCenter.vue?vue&type=script&lang=ts&"
export * from "./AccountCenter.vue?vue&type=script&lang=ts&"
import style0 from "./AccountCenter.vue?vue&type=style&index=0&id=1b5911cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5911cc",
  null
  
)

export default component.exports